<div class="row" *ngIf="!noCharacteristicsData;else noData">
  <div>
    <table class="width">
      <tr class="fixed-income-header">
        <th class="row-header">Fundamental</th>
        <th>{{fundId}}</th>
        <th *ngIf="(!portfolioModel?.profileData?.isExternalFund) && (portfolioModel?.profileData?.fundId !== '0517')">
          <div class="tool-tip-cell" *ngIf="(!portfolioModel?.profileData?.isBalanced)">
            <label>Benchmark<sup *ngIf="portfolioModel?.profileData?.isBalanced">{{benchmarkFootNote?.id}}</sup></label>
            <c11n-tooltip [autoOrientation]="false" colorMode="on-light" direction="left" labelText="Benchmark">
              <span c11nTooltipContent>{{ fixedIncomeCharacteristic?.benchmarkShortName || '(Benchmark)'}}</span>
            </c11n-tooltip>
          </div>
          <div class="tool-tip-cell" *ngIf="portfolioModel?.profileData?.isBalanced">
            <label>Benchmark<sup *ngIf="portfolioModel?.profileData?.isBalanced">{{benchmarkFootNote?.id}}</sup></label>
            <c11n-tooltip [autoOrientation]="false" colorMode="on-light" direction="left" labelText="Benchmark">
              <span c11nTooltipContent>{{ fixedIncomeCharacteristic?.benchmarkShortName || '(Benchmark)'}}</span>
            </c11n-tooltip>
          </div>
        </th>
      </tr>
      <tr class="fixed-income">
        <td class="row-header">Number of bonds</td>
        <td data-rpa-tag-id="symbolNumOfBonds">
          {{ fixedIncomeCharacteristic?.fund?.numberOfBonds ? fixedIncomeCharacteristic?.fund?.numberOfBonds: '&mdash;'
          }}
        </td>
        <td *ngIf="(portfolioModel?.profileData?.fundId !== '0517') && (!portfolioModel?.profileData?.isExternalFund)"
          data-rpa-tag-id="benchmarkNumOfBonds">
          {{ fixedIncomeCharacteristic?.benchmark?.numberOfBonds ? fixedIncomeCharacteristic?.benchmark?.numberOfBonds:
          '&mdash;' }}
        </td>
      </tr>
      <tr class="fixed-income">
        <td class="row-header"><a role="button" tabindex="0" class="link fixed-link dialog-button"
            (click)="setDialogInfo('Yield to maturity');fixedIncomeCharacteristicDialog.openModalDialog();" href="javascript:void(0)">
            Yield to maturity</a><sup class="footnote"
            *ngIf="((portfolioModel?.profileData?.isETF || portfolioModel?.profileData?.isMutualFund) &&
                   portfolioModel?.profileData?.fundCategoryId === 3114)">{{portfolioModel?.yieldToMaturityFootNote?.id}}</sup>
        </td>
        <td data-rpa-tag-id="symbolYieldToMaturity">
          {{ fixedIncomeCharacteristic?.fund?.yieldToMaturity ? fixedIncomeCharacteristic?.fund?.yieldToMaturity + '%':
          '&mdash;' }}
        </td>
        <td *ngIf="(portfolioModel?.profileData?.fundId !== '0517') && (!portfolioModel?.profileData?.isExternalFund)"
          data-rpa-tag-id="benchmarkYieldToMaturity">
          {{ fixedIncomeCharacteristic?.benchmark?.yieldToMaturity ?
          fixedIncomeCharacteristic?.benchmark?.yieldToMaturity + '%': '&mdash;' }}
        </td>
      </tr>
      <tr class="fixed-income">
        <td class="row-header">Average coupon</td>
        <td data-rpa-tag-id="symbolAvgCoupon">
          {{ fixedIncomeCharacteristic?.fund?.averageCoupon ? fixedIncomeCharacteristic?.fund?.averageCoupon + '%':
          '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund) && (portfolioModel?.profileData?.fundId !== '0517')"
          data-rpa-tag-id="benchmarkAvgCoupon">
          {{ fixedIncomeCharacteristic?.benchmark?.averageCoupon ? fixedIncomeCharacteristic?.benchmark?.averageCoupon +
          '%': '&mdash;' }}
        </td>
      </tr>
      <tr class="fixed-income" *ngIf="fixedIncomeCharacteristic?.fund?.averageMaturityType === 'E'">
        <td class="row-header"><a role="button" tabindex="0"
          href="javascript:void(0)"
          class="link fixed-link dialog-button"
          (click)="setDialogInfo('Average Effective Maturity (taxable bond funds and balanced funds except tax-managed balanced)');fixedIncomeCharacteristicDialog.openModalDialog();">
            Average effective maturity</a>
        </td>
        <td data-rpa-tag-id="symbolAvgEffectiveMaturity">
          {{ fixedIncomeCharacteristic?.fund?.averageMaturity ? fixedIncomeCharacteristic?.fund?.averageMaturity:
          '&mdash;' }}
        </td>
        <td *ngIf="(portfolioModel?.profileData?.fundId !== '0517') && (!portfolioModel?.profileData?.isExternalFund)"
          data-rpa-tag-id="benchmarkAvgEffectiveMaturity">
          {{ fixedIncomeCharacteristic?.benchmark?.averageMaturity ?
          fixedIncomeCharacteristic?.benchmark?.averageMaturity: '&mdash;' }}
        </td>
      </tr>
      <tr class="fixed-income" *ngIf="fixedIncomeCharacteristic?.fund?.averageMaturityType === 'S'">
        <td class="row-header"><a class="link fixed-link dialog-button" role="button" tabindex="0"
            (click)="setDialogInfo('Average Stated Maturity (municipal bond funds and tax-managed balanced)');fixedIncomeCharacteristicDialog.openModalDialog();"
            href="javascript:void(0)">
            Average stated maturity</a>
        </td>
        <td data-rpa-tag-id="symbolAvgMaturity">
          {{ fixedIncomeCharacteristic?.fund?.averageMaturity ? fixedIncomeCharacteristic?.fund?.averageMaturity:
          '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkAvgMaturity">
          {{ fixedIncomeCharacteristic?.benchmark?.averageMaturity ?
          fixedIncomeCharacteristic?.benchmark?.averageMaturity: '&mdash;' }}
        </td>
      </tr>
      <tr class="fixed-income" *ngIf="portfolioModel?.profileData?.isExternalFund">
        <td class="row-header"><a class="link link fixed-link dialog-button" role="button" tabindex="0"
            (click)="setDialogInfo('Average Maturity (money market funds only)');fixedIncomeCharacteristicDialog.openModalDialog();"
            href="javascript:void(0)">
            Average maturity</a>
        </td>
        <td data-rpa-tag-id="symbolAvgMaturity">
          {{ fixedIncomeCharacteristic?.fund?.averageMaturity ? fixedIncomeCharacteristic?.fund?.averageMaturity:
          '&mdash;' }}
        </td>
      </tr>
      <tr class="fixed-income">
        <td class="row-header"><a class="link link fixed-link dialog-button" role="button" tabindex="0"
            (click)="setDialogInfo('Duration');fixedIncomeCharacteristicDialog.openModalDialog();" href="javascript:void(0)">
            Average duration</a><sup class="footnote"
            *ngIf="((portfolioModel?.profileData?.isETF || portfolioModel?.profileData?.isMutualFund) &&
                   portfolioModel?.profileData?.fundCategoryId === 3114)">{{portfolioModel?.averageDurationFootNote?.id}}</sup>
        </td>
        <td data-rpa-tag-id="symbolAvgDuration">
          {{ fixedIncomeCharacteristic?.fund?.averageDuration ? fixedIncomeCharacteristic?.fund?.averageDuration:
          '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund) && (portfolioModel?.profileData?.fundId !== '0517')"
          data-rpa-tag-id="benchmarkAvgDuration">
          {{ fixedIncomeCharacteristic?.benchmark?.averageDuration ?
          fixedIncomeCharacteristic?.benchmark?.averageDuration: '&mdash;' }}
        </td>
      </tr>
      <tr class="fixed-income" *ngIf="portfolioModel?.profileData?.isTaxExemptBondFund">
        <td class="row-header"><a class="link link fixed-link dialog-button" role="button" tabindex="0"
            (click)="setDialogInfo('Alternative minimum tax (AMT)');fixedIncomeCharacteristicDialog.openModalDialog();" href="javascript:void(0)">
            Alternative minimum tax (AMT)</a><sup
            class="footnote">{{portfolioModel?.taxExemptBondFundFootNote?.id}}</sup></td>
        <td data-rpa-tag-id="symbolAlternateMinTax">
          {{ fixedIncomeCharacteristic?.fund?.alternativeMinimumTax ?
          fixedIncomeCharacteristic?.fund?.alternativeMinimumTax + '%': '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkAlternateMinTax">
          {{ fixedIncomeCharacteristic?.benchmark?.alternativeMinimumTax ?
          fixedIncomeCharacteristic?.benchmark?.alternativeMinimumTax + '%': '&mdash;' }}
        </td>
      </tr>
      <tr class="fixed-income" *ngIf="((!portfolioModel?.profileData?.isETF && portfolioModel?.profileData?.isBond) ||
      (portfolioModel?.profileData?.isETF))">
        <td class="row-header">Short-term reserves</td>
        <td data-rpa-tag-id="symbolShortTermReserves">
          {{ fixedIncomeCharacteristic?.fund?.shortTermReserves ? fixedIncomeCharacteristic?.fund?.shortTermReserves +
          '%' : '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkShortTermReserves">
          {{ fixedIncomeCharacteristic?.benchmark?.shortTermReserves ?
          fixedIncomeCharacteristic?.benchmark?.shortTermReserves + '%' : '&mdash;' }}
        </td>
      </tr>
      <tr class="fixed-income"
        *ngIf="fixedIncomeCharacteristic?.fund?.totalNetAssets && portfolioModel?.profileData?.isBond">
        <td class="row-header">Fund total net assets as of
          {{ fixedIncomeCharacteristic?.fund?.totalNetAssetsDate | ESTPipe }}</td>
        <td data-rpa-tag-id="symbolFundNetAssets">
          {{ fixedIncomeCharacteristic?.fund?.totalNetAssets ? (fixedIncomeCharacteristic?.fund?.totalNetAssets |
          amount) : '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund)" data-rpa-tag-id="benchmarkFundNetAssets">
          {{ fixedIncomeCharacteristic?.benchmark?.totalNetAssets ?
          (fixedIncomeCharacteristic?.benchmark?.totalNetAssets | amount) : '&mdash;' }}
        </td>
      </tr>
      <tr class="fixed-income" *ngIf="fixedIncomeCharacteristic?.fund?.shareClassTotalNetAssets && portfolioModel?.profileData?.isBond
       && portfolioModel?.profileData?.hasMoreThan1ShareClass">
        <td class="row-header">Share class total net assets</td>
        <td data-rpa-tag-id="symbolShareNetAssets">
          {{ fixedIncomeCharacteristic?.fund?.shareClassTotalNetAssets ?
          (fixedIncomeCharacteristic?.fund?.shareClassTotalNetAssets | amount) : '&mdash;' }}
        </td>
        <td data-rpa-tag-id="benchmarkShareNetAssets">
          {{ fixedIncomeCharacteristic?.benchmark?.shareClassTotalNetAssets ?
          (fixedIncomeCharacteristic?.benchmark?.shareClassTotalNetAssets | amount) : '&mdash;' }}
        </td>
      </tr>
      <tr class="fixed-income"
        *ngIf="(fixedIncomeCharacteristic?.fund?.turnoverRate && !portfolioModel?.profileData?.isBalanced )">
        <td class="row-header">
          Turnover rate (Fiscal Year-end {{fixedIncomeCharacteristic?.fund?.turnoverRateDate | ESTPipe }})
        </td>
        <td data-rpa-tag-id="symbolTurnoverRate"> {{ fixedIncomeCharacteristic?.fund?.turnoverRate ?
          fixedIncomeCharacteristic?.fund?.turnoverRate + '%' : '&mdash;' }}
        </td>
        <td *ngIf="(!portfolioModel?.profileData?.isExternalFund) && (portfolioModel?.profileData?.fundId !== '0517')"
          data-rpa-tag-id="benchmarkTurnoverRate">
          {{ fixedIncomeCharacteristic?.benchmark?.turnoverRate ? fixedIncomeCharacteristic?.benchmark?.turnoverRate +
          '%' : '&mdash;' }}
        </td>
      </tr>
    </table>
  </div>
</div>

<ng-template #noData>
  <p *ngIf="noCharacteristicsData" class="no-data">This information is temporarily unavailable.</p>
</ng-template>

<c11n-modal-dialog
  modalId="fixedIncomeCharacteristicDialog"
  [headingText]="dialogTitle"
  #fixedIncomeCharacteristicDialog>
  <div c11n-modal-dialog-body>
    <ng-container #dialogBodyContainer></ng-container>
  </div>
</c11n-modal-dialog>

<ng-template #simpleDialogBodyContent>
  <p [innerHTML]="dialogBody"></p>
</ng-template>

<ng-template #averageMaturityDialogBodyContent>
  <h2 id="averageEffectiveMaturityPopupDialogTitle" class="dialog-subheader">Average Effective Maturity (taxable
    bond funds and balanced funds except Tax-Managed Balanced)</h2>
  <p id="yieldToMaturityPopupDialogDesc" [innerHTML]="averageEffectiveMaturity?.contentValue">
  </p>
  <h2 id="averageStatedMaturityPopupDialogTitle" class="dialog-subheader">Average Stated Maturity (municipal bond
    funds and tax-managed balanced)</h2>
  <p id="yieldToMaturityPopupDialogDesc" [innerHTML]="averageStatedMaturity?.contentValue">
  </p>
  <h2 id="averageStatedMaturityPopupDialogTitle" class="dialog-subheader">Average Maturity (money market funds only)
  </h2>
  <p id="yieldToMaturityPopupDialogDesc" [innerHTML]="averageMaturity?.contentValue"></p>
</ng-template>